import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { apiFetch, setToken } from "../api";

export function SignupPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const signupMutation = useMutation({
    mutationFn: (credentials: { email: string; password: string }) =>
      apiFetch<{ token: string }>("/api/auth/signup", {
        method: "POST",
        body: JSON.stringify(credentials),
      }),
    onSuccess: (data) => {
      setToken(data.token);
      window.location.href = "/dashboard";
    },
  });

  const error =
    passwordError || ((signupMutation.error as Error)?.message ?? "");
  const loading = signupMutation.isPending;

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setPasswordError("");

    if (password !== confirm) {
      setPasswordError("Passwords do not match");
      return;
    }

    signupMutation.mutate({ email, password });
  }

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={handleSubmit}>
        <h1>Create account</h1>
        <p className="auth-subtitle">Get started with SiteChatAgent</p>

        {error && <div className="auth-error">{error}</div>}

        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="you@company.com"
            required
            autoFocus
          />
        </label>

        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="At least 6 characters"
            required
            minLength={6}
          />
        </label>

        <label>
          Confirm password
          <input
            type="password"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            placeholder="Repeat your password"
            required
          />
        </label>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Creating account..." : "Sign up"}
        </button>

        <p className="auth-footer">
          Already have an account? <a href="/login">Log in</a>
        </p>
      </form>
    </div>
  );
}
